import apiClient from './apiClient';
import { BlockedCustomer } from '../types/blockedCustomer';

const API_URL = '/users_edit'; // URLを修正

// NG電話番号を追加するためのデータ型
export type AddBlockedCustomerData = {
  phone_number: string;
  notes?: string;
};

// ユーザー（キャスト）に関連するNG電話番号を取得
export const getBlockedCustomers = async (userId: number): Promise<BlockedCustomer[]> => {
  const response = await apiClient.get<BlockedCustomer[]>(`${API_URL}/${userId}/blocked_customers`);
  return response.data;
};

// NG電話番号を追加
export const addBlockedCustomer = async (userId: number, data: AddBlockedCustomerData): Promise<BlockedCustomer> => {
  const response = await apiClient.post<BlockedCustomer>(`${API_URL}/${userId}/blocked_customers`, data);
  return response.data;
};

// NG電話番号を削除
export const deleteBlockedCustomer = async (userId: number, blockedCustomerId: number): Promise<void> => {
  await apiClient.delete(`${API_URL}/${userId}/blocked_customers/${blockedCustomerId}`);
};

const blockedCustomerService = {
  getBlockedCustomers,
  addBlockedCustomer,
  deleteBlockedCustomer,
};

export default blockedCustomerService; 